<app-notification-bar
  *ngIf="showAnnouncement"
  type="info"
  [closeable]="true"
  [persistKey]="announcementId"
  href="https://kakomon.obunsha.co.jp/topic/5pq52uh9nbv"
  target="_blank"
>
  【重要】「入試正解デジタル for School」高等学校向け価格改定のお知らせ（2026年9月1日実施）
</app-notification-bar>
<app-top-header></app-top-header>
<main class="top-root">
  <div class="top-wrapper">
    <header class="top-header-static">
      <div class="top-header-static-logo md:hidden">
        <img
          src="assets/images/app-logo-for-school-with-company-horizontal.svg"
          alt="入試正解デジタル for School"
          width="510"
          height="98"
        />
      </div>
      <div class="top-header-static-buttons">
        <button
          id="btn-header-installation"
          class="max-xs:hidden max-sm:text-sm"
          mat-flat-button
          color="primary"
          (click)="openInstallationDialog()"
        >
          新規導入の申し込み
        </button>
        <button
          id="btn-header-login"
          class="max-xs:text-xs inline-block border-primary text-primary md:w-40"
          mat-stroked-button
          (click)="gotoSearch()"
        >
          ログイン
        </button>
      </div>
    </header>
    <div id="introduction" class="introduction">
      <section class="section-hero">
        <div class="introduction-wrapper">
          <div class="section-hero-picture">
            <div class="section-hero-picture-item">
              <picture>
                <source media="(min-width: 780px)" srcset="/assets/images/lp/hero@2x.jpg 2x, /assets/images/lp/hero.jpg" />
                <img srcset="/assets/images/lp/hero.jpg" alt="入試正解デジタル画面イメージ" width="930" height="614" />
              </picture>
            </div>
            <div class="section-hero-dot bg-dot hidden md:block"></div>
          </div>

          <div class="section-hero-item">
            <div class="section-hero-title">
              <p class="section-hero-eyebrow mt-8 mb-4 text-center md:mt-0 md:mb-[4.25rem] md:text-left">大学入試過去問Webサービス</p>
              <h1 class="section-hero-title-logo hidden md:block">
                <img src="assets/images/app-logo-for-school-with-company.svg" alt="入試正解デジタル for School" width="510" height="98" />
              </h1>
            </div>

            <div class="section-hero-buttons mb-4 md:mt-[5.5rem]">
              <button
                id="cv-top-installation"
                class="mt-4 block w-full mat-button-override-large-in-lp cta-button-primary"
                mat-flat-button
                (click)="openInstallationDialog()"
              >
                新規導入の申し込み
              </button>
              <button
                id="cv-top-free-trial"
                class="mt-4 block w-full mat-button-override-large-in-lp cta-button-secondary"
                mat-flat-button
                (click)="freeTrialApplicationUrlClickHandler()"
              >
                無料体験の申し込み
              </button>
            </div>
          </div>
        </div>
      </section>
      <section class="section-lead">
        <div class="introduction-wrapper">
          <p class="section-lead-eyebrow">「一般選抜」も、「推薦・総合型選抜」も</p>
          <h2 class="section-lead-title">授業での<br class="md:hidden" />入試問題演習が変わる</h2>
          <p class="section-lead-desc">
            <strong>入試正解デジタル for School</strong
            >は、旺文社が刊行する『<strong>全国大学入試問題正解</strong>』『<strong>螢雪時代7月臨時増刊</strong>』に掲載された大学入試過去問をスムーズに検索・閲覧・印刷配布できるWebサービスです。
          </p>
          <p class="section-lead-note">
            詳しくは「<button class="text-primary underline hover:no-underline" (click)="anchorScrollingHandler('subject')">
              対応科目</button
            >」と「<button class="text-primary underline hover:no-underline" (click)="anchorScrollingHandler('price')">
              プランと料金</button
            >」をご確認ください。
          </p>
          <hr class="section-divider md:hidden" />
        </div>
      </section>
      <section class="section-plans">
        <div class="introduction-wrapper">
          <div class="section-plans-grid">
            <!-- 一般選抜 -->
            <div class="plan-col">
              <h3 class="plan-col-heading">
                <mat-icon class="plan-col-icon plan-col-icon--ippan" aria-hidden="true">edit_note</mat-icon>
                <span>一般選抜</span>
              </h3>
              <div class="plan-col-figure plan-col-figure--ippan">
                <div class="plan-col-dot bg-dot hidden md:block" aria-hidden="true"></div>
                <picture>
                  <source media="(max-width: 899px)" srcset="/assets/images/lp/books-ippan@2x.jpg 2x, /assets/images/lp/books-ippan.jpg" />
                  <source media="(min-width: 900px)" srcset="/assets/images/lp/books-ippan@2x.jpg 2x, /assets/images/lp/books-ippan.jpg" />
                  <img
                    class="plan-col-image"
                    src="/assets/images/lp/books-ippan@2x.jpg"
                    width="519"
                    height="365"
                    alt="全国大学入試問題正解 一般選抜用の書影"
                    loading="lazy"
                  />
                </picture>
              </div>
              <h4 class="plan-col-title">
                200大学以上の過去問を、<br class="hidden md:block" /><span class="text-primary">『全国大学入試問題正解』</span>から掲載！
              </h4>
              <p class="plan-col-desc">
                <span class="hidden md:inline"
                  >『全国大学入試問題正解』は、国公私立大学の入試情報や入試傾向、科目の特徴がわかる書籍で、全国2,000校以上の高等学校に採用されています。
                  主に進路指導室や教科室、職員室に設置され、授業や補講、過去問演習の現場で広く利用されています。</span
                >
                <span class="md:hidden"
                  >旺文社『全国大学入試問題正解』掲載の大学入試過去問を検索できるWebアプリケーションです。『全国大学入試問題正解』は、国公私立大学の入試情報、入試傾向や科目の特徴がわかる書籍で、2,000校以上の高等学校に採用されています。</span
                >
              </p>
              <hr class="section-divider md:hidden" />
            </div>
            <!-- 推薦・総合型選抜 -->
            <div class="plan-col">
              <h3 class="plan-col-heading">
                <mat-icon class="plan-col-icon plan-col-icon--suisen" aria-hidden="true">how_to_reg</mat-icon>
                <span>推薦・総合型選抜</span>
              </h3>
              <div class="plan-col-figure">
                <picture>
                  <source
                    media="(max-width: 899px)"
                    srcset="/assets/images/lp/books-suisen@2x.jpg 2x, /assets/images/lp/books-suisen.jpg"
                  />
                  <source
                    media="(min-width: 900px)"
                    srcset="/assets/images/lp/books-suisen@2x.jpg 2x, /assets/images/lp/books-suisen.jpg"
                  />
                  <img
                    class="plan-col-image"
                    src="/assets/images/lp/books-suisen@2x.jpg"
                    width="519"
                    height="365"
                    alt="学校推薦型・総合型選抜用の書影"
                    loading="lazy"
                  />
                </picture>
                <span class="plan-col-badge">NEW</span>
              </div>
              <h4 class="plan-col-title">
                <span class="text-primary">学校推薦型・総合型</span>の過去問を、<br class="hidden md:block" />約90大学分掲載！
              </h4>
              <p class="plan-col-desc">
                <span class="hidden md:inline"
                  >『全国大学入試問題正解
                  学校推薦型選抜総合型選抜（私立大）』『螢雪時代7月臨時増刊』掲載の推薦・総合型選抜の過去問が搭載されました。各誌の解答・解説も掲載しており、変化の激しい年内入試の指導において、資料収集の手間を省き、質・量ともに厚みのある生徒支援を可能にします。</span
                >
                <span class="md:hidden"
                  >『全国大学入試問題正解
                  学校推薦型選抜総合型選抜（私立大）』『螢雪時代7月臨時増刊』掲載の推薦・総合型選抜の過去問が搭載されました。各書籍の解答・解説も掲載しており、変化の激しい年内入試の指導において、資料収集の手間を省き、質・量ともに厚みのある生徒支援を可能にします。</span
                >
              </p>
              <p class="plan-col-note">※ 入試正解デジタルへの搭載は入試問題のみで、面接試験を含むその他の入試情報は除きます。</p>
            </div>
          </div>
          <hr class="section-divider section-divider--between" />
        </div>
      </section>
      <section class="section-about">
        <div class="introduction-wrapper">
          <h2 class="introduction-lead section-about-item">
            <div>豊富な検索項目から</div>
            <div><span class="text-primary">『大学入試の過去問』</span>が見つかる</div>
          </h2>
          <p class="md:w-5/12 section-about-item section-about-desc">
            膨大な書籍から時間をかけて問題を探す負担を軽減し、検索項目をチェックするだけで、使いたい問題がすぐに見つかるようになります。<br />
            入試問題演習や授業で使うプリント作成、過去問の研究にお役立ていただけます。
          </p>
        </div>
        <div class="section-about-gallery grid grid-cols-2">
          <div class="section-about-gallery-col pt-8 md:pt-28">
            <picture>
              <source media="(min-width: 780px)" srcset="/assets/images/lp/school-1@2x.jpg 2x, /assets/images/lp/school-1.jpg" />
              <img class="section-about-gallery-item" srcset="/assets/images/lp/school-1.jpg" width="320" height="214" alt="" />
            </picture>
            <picture>
              <source media="(min-width: 780px)" srcset="/assets/images/lp/school-2@2x.jpg 2x, /assets/images/lp/school-2.jpg" />
              <img class="section-about-gallery-item" srcset="/assets/images/lp/school-2.jpg" alt="" width="320" height="256" />
            </picture>
          </div>
          <div class="section-about-gallery-col">
            <picture>
              <source media="(min-width: 780px)" srcset="/assets/images/lp/school-3@2x.jpg 2x, /assets/images/lp/school-3.jpg" />
              <img class="section-about-gallery-item" srcset="/assets/images/lp/school-3.jpg" width="320" height="214" alt="" />
            </picture>
            <picture>
              <source media="(min-width: 780px)" srcset="/assets/images/lp/school-4@2x.jpg 2x, /assets/images/lp/school-4.jpg" />
              <img class="section-about-gallery-item" srcset="/assets/images/lp/school-4.jpg" width="320" height="214" alt="" />
            </picture>
          </div>
        </div>
      </section>
      <div class="section-about-bg">
        <picture>
          <source media="(min-width: 780px)" srcset="/assets/images/lp/laptop@2x.jpg 2x, /assets/images/lp/laptop.jpg" />
          <img srcset="/assets/images/lp/laptop.jpg" width="750" height="537" alt="" />
        </picture>
      </div>
    </div>

    <section id="service" class="section-basic" data-bg="gray-darker">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">SERVICE</span>
        <strong class="section-basic-header-title">サービスの特徴</strong>
      </h2>
      <app-wrapper size="lg">
        <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-1 md:gap-8 mb-4">
          <section class="service-item">
            <div class="md:flex md:items-center">
              <div class="grow md:w-1/2">
                <picture>
                  <source
                    media="(min-width: 780px)"
                    srcset="/assets/images/lp/service-picture-1@2x.jpg 2x, /assets/images/lp/service-picture-1.jpg"
                  />
                  <img
                    class="service-item-picture"
                    srcset="/assets/images/lp/service-picture-1@2x.jpg"
                    width="576"
                    height="410"
                    loading="lazy"
                    alt=""
                  />
                </picture>
              </div>
              <div class="grow md:w-1/2 p-8 md:p-12">
                <div class="service-item-title">
                  <div class="service-item-title-icon">
                    <mat-icon aria-hidden="true">grading</mat-icon>
                  </div>
                  <h3 class="service-item-title-text">
                    <span class="inline-block"> 詳細な解答・解説付き<span class="text-sm" style="vertical-align: super;">※</span> </span>
                  </h3>
                </div>
                <div class="mt-4 md:mt-6 md:text-md lg:text-base">
                  <p>
                    「全国大学入試問題正解」掲載の解答・解説を収録！<br />
                    長年、大学・高校・予備校の教育にたずさわっているベテランの先生方による正確でわかりやすい親切な解答・解説をつけています。
                  </p>
                  <p>
                    <small>※ 一部「問題・解答のみ」を掲載</small>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="service-item">
            <div class="md:flex md:items-center md:flex-row-reverse">
              <div class="grow md:w-1/2">
                <picture>
                  <source
                    media="(min-width: 780px)"
                    srcset="/assets/images/lp/service-picture-2@2x.jpg 2x, /assets/images/lp/service-picture-2.jpg"
                  />
                  <img
                    class="service-item-picture"
                    srcset="/assets/images/lp/service-picture-2@2x.jpg"
                    width="576"
                    height="410"
                    loading="lazy"
                    alt=""
                  />
                </picture>
              </div>
              <div class="grow md:w-1/2 p-8 md:p-12">
                <div class="service-item-title">
                  <div class="service-item-title-icon">
                    <mat-icon aria-hidden="true">search</mat-icon>
                  </div>
                  <h3 class="service-item-title-text">
                    検索項目が細かく豊富
                  </h3>
                </div>
                <div class="mt-4 md:mt-6 md:text-md lg:text-base">
                  「分野」「大学名」での検索はもちろん、思考力問題や複数年度にわたっての検索も可能です。<br />
                  さらに、問題文や解答・解説に含まれるキーワードを「フリーワード検索」（AND/OR検索対応）でも探すことができ、効率的に過去問を絞り込めます。<br />
                  科目特有の検索項目（国語の「素材文のジャンル」での絞り込みや、英語長文の「英単語数の絞り込み」）も充実。<br />
                  生徒に適した問題をスムーズに見つけることができます。
                </div>
              </div>
            </div>
          </section>
          <section class="service-item">
            <div class="md:flex md:items-center">
              <div class="grow md:w-1/2">
                <picture>
                  <source
                    media="(min-width: 780px)"
                    srcset="/assets/images/lp/service-picture-3@2x.jpg 2x, /assets/images/lp/service-picture-3.jpg"
                  />
                  <img
                    class="service-item-picture"
                    srcset="/assets/images/lp/service-picture-3@2x.jpg"
                    width="576"
                    height="410"
                    loading="lazy"
                    alt=""
                  />
                </picture>
              </div>
              <div class="grow md:w-1/2 p-8 md:p-12">
                <div class="service-item-title">
                  <div class="service-item-title-icon">
                    <!-- <mat-icon aria-hidden="true">design_services</mat-icon> -->
                    <mat-icon aria-hidden="true">print</mat-icon>
                  </div>
                  <h3 class="service-item-title-text">授業目的にあわせて<br />プリント作成・印刷が可能</h3>
                </div>
                <div class="mt-4 md:mt-6 md:text-md lg:text-base">
                  <p>
                    閲覧・印刷は「試験単位でまとめて」「大問ごとに分けて」より選べます。また、MicrosoftⓇWord形式で問題、解答・解説データをダウンロードできます。<br />
                    志望校対策や苦手分野の集中対策など、授業の目的にあわせてご活用いただけます。
                  </p>
                  <p>
                    <small>※ 一部「問題・解答のみ」を掲載</small>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="service-item">
            <div class="md:flex md:items-center md:flex-row-reverse">
              <div class="grow md:w-1/2">
                <picture>
                  <source
                    media="(min-width: 780px)"
                    srcset="/assets/images/lp/service-picture-4@2x.jpg 2x, /assets/images/lp/service-picture-4.jpg"
                  />
                  <img
                    class="service-item-picture"
                    srcset="/assets/images/lp/service-picture-4@2x.jpg"
                    width="576"
                    height="410"
                    loading="lazy"
                    alt=""
                  />
                </picture>
              </div>
              <div class="grow md:w-1/2 p-8 md:p-12">
                <div class="service-item-title">
                  <div class="service-item-title-icon">
                    <mat-icon aria-hidden="true">insert_drive_file</mat-icon>
                  </div>
                  <h3 class="service-item-title-text">
                    <span class="inline-block">すぐに授業で使える</span>
                    <span class="inline-block">プリント集</span>
                  </h3>
                </div>
                <div class="mt-4 md:mt-6 md:text-md lg:text-base">
                  各大学の過去問から、旺文社編集部や特別講師が選出した授業や講義で使える問題と解答・解説をご用意！<br />
                  「おすすめ問題セット」をぜひ、教材の一つとして利用ください。
                </div>
              </div>
            </div>
          </section>
          <section class="service-item">
            <div class="md:flex md:items-center">
              <div class="grow md:w-1/2">
                <picture>
                  <source
                    media="(min-width: 780px)"
                    srcset="/assets/images/lp/service-picture-5@2x.jpg 2x, /assets/images/lp/service-picture-5.jpg"
                  />
                  <img
                    class="service-item-picture"
                    srcset="/assets/images/lp/service-picture-5@2x.jpg"
                    width="576"
                    height="410"
                    loading="lazy"
                    alt=""
                  />
                </picture>
              </div>
              <div class="grow md:w-1/2 p-8 md:p-12">
                <div class="service-item-title">
                  <div class="service-item-title-icon">
                    <mat-icon aria-hidden="true">star</mat-icon>
                  </div>
                  <h3 class="service-item-title-text">
                    <span class="inline-block">オリジナル問題セットを</span>
                    <span class="inline-block">作成・管理できる</span>
                  </h3>
                </div>
                <div class="mt-4 md:mt-6 md:text-md lg:text-base">
                  検索した問題を「お気に入り管理」のリストに登録すると、オリジナル問題セットが作れます。
                  リスト内の問題、解答・解説をまとめて印刷ができるので、すぐに授業で配布できます。作ったリストは学校内での共有も可能です。
                </div>
              </div>
            </div>
          </section>
        </div>
      </app-wrapper>
    </section>

    <!-- INTERVIEWセクション -->
    <section id="interview" class="section-basic" data-bg="gray-pattern">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">INTERVIEW</span>
        <strong class="section-basic-header-title">利用者様の声</strong>
      </h2>

      <app-content-lp-interview-section></app-content-lp-interview-section>
    </section>

    <!--
    <section id="voice" class="section-basic" data-bg="gray-pattern">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">VOICE</span>
        <strong class="section-basic-header-title">先生の声</strong>
      </h2>
      <div class="mb-12">
        <p class="text-center -mt-4">ご採用校の先生方の声を紹介します</p>
      </div>
      <app-wrapper size="md">
        <div class="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 md:grid-cols-3 md:gap-x-10 md:gap-y-12 mb-6">
          <div class="voice-item">
            <p class="voice-item-message">主に読解問題を生徒の自習用のプリント教材として使っていて、生徒に好評です。</p>
            <div class="voice-item-person">
              <div class="voice-item-person-avatar">
                <img src="/assets/images/lp/voice-thumb-1.png" alt="英語" />
              </div>
              <div class="voice-item-person-name">英語の先生</div>
            </div>
          </div>
          <div class="voice-item">
            <p class="voice-item-message">
              生徒に追加演習として入試正解デジタルから出題することがあります。もう1問を出題したいときに検索しやすく便利です。大学名を見て、難しい問題にもチャレンジしようという生徒の意識が高くなりました。
            </p>
            <div class="voice-item-person">
              <div class="voice-item-person-avatar">
                <img src="/assets/images/lp/voice-thumb-2.png" alt="数学" />
              </div>
              <div class="voice-item-person-name">数学の先生</div>
            </div>
          </div>
          <div class="voice-item">
            <p class="voice-item-message">
              解説が充実している点は、他社商品にはないため大変助かります。操作に慣れてきたら、さらに活用できそうです。
            </p>
            <div class="voice-item-person">
              <div class="voice-item-person-avatar">
                <img src="/assets/images/lp/voice-thumb-3.png" alt="生物" />
              </div>
              <div class="voice-item-person-name">生物の先生</div>
            </div>
          </div>
          <div class="voice-item">
            <p class="voice-item-message">
              分野別・難度別・年度別・国公私別・地域別に問題を検索できることや、問題と解答を別に印刷できることが便利です。
            </p>
            <div class="voice-item-person">
              <div class="voice-item-person-avatar">
                <img src="/assets/images/lp/voice-thumb-4.png" alt="物理" />
              </div>
              <div class="voice-item-person-name">物理の先生</div>
            </div>
          </div>
          <div class="voice-item">
            <p class="voice-item-message">授業内での演習や、長期休みの講習で使用しています。デジタルで検索できることは、本より便利です。</p>
            <div class="voice-item-person">
              <div class="voice-item-person-avatar">
                <img src="/assets/images/lp/voice-thumb-5.png" alt="世界史" />
              </div>
              <div class="voice-item-person-name">世界史の先生</div>
            </div>
          </div>
          <div class="voice-item">
            <p class="voice-item-message">
              書籍で調べるより格段に速くなり、業務の効率化につながっています。大学別に出てくるので、大学ごとの演習にも適しているように思います。
            </p>
            <div class="voice-item-person">
              <div class="voice-item-person-avatar">
                <img src="/assets/images/lp/voice-thumb-6.png" alt="数学" />
              </div>
              <div class="voice-item-person-name">数学の先生</div>
            </div>
          </div>
        </div>
      </app-wrapper>
    </section>
    -->

    <section id="subject" class="section-basic" data-bg="gray">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">SUBJECT</span>
        <strong class="section-basic-header-title">対応科目</strong>
      </h2>
      <app-wrapper size="md">
        <div>
          <div class="flex items-center justify-center md:justify-end gap-2 text-xs md:text-sm mb-2 md:mb-1">
            <div class="flex items-center">
              <span>
                <span class="icon-subject-info" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                  ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                >
              </span>
              <span>
                問題・解答掲載あり
              </span>
            </div>
            <div class="flex items-center">
              <span>
                <span class="icon-subject-info" matTooltip="Wordデータ掲載あり" matTooltipPosition="above"
                  ><app-icon-word aria-label="Wordデータ掲載あり"></app-icon-word
                ></span>
              </span>
              <span>Wordデータ掲載あり</span>
            </div>
          </div>

          <app-overflow-wrapper-x>
            <table class="table-subject" style="min-width: 680px;">
              <tr>
                <th class="bg-gray-30 border-t-0 border-l-0" style="min-width:7em;"></th>
                <th class="text-xs md:text-sm">2025</th>
                <th class="text-xs md:text-sm">2024</th>
                <th class="text-xs md:text-sm">2023</th>
                <th class="text-xs md:text-sm">2022</th>
                <th class="text-xs md:text-sm">2021</th>
                <th class="text-xs md:text-sm">2020</th>
                <th class="text-xs md:text-sm">2019</th>
                <th class="text-xs md:text-sm">2018</th>
                <th class="text-xs md:text-sm">2017</th>
                <th class="text-xs md:text-sm">2016</th>
                <th class="text-xs md:text-sm">2015</th>
                <th class="text-xs md:text-sm">対応書籍</th>
              </tr>
              <tr>
                <th>数学</th>
                <td rowspan="3" colspan="7">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                  <span class="icon-subject-info px-1" matTooltip="Wordデータ掲載あり" matTooltipPosition="above"
                    ><app-icon-word aria-label="Wordデータ掲載あり"></app-icon-word
                  ></span>
                </td>
                <td rowspan="3" colspan="4">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                </td>
                <td class="text-xs md:text-sm">私立大、国公立大、追加掲載編</td>
              </tr>
              <tr>
                <th>物理</th>
                <td class="text-xs md:text-sm">物理、理科追加掲載編（物理）</td>
              </tr>
              <tr>
                <th>化学</th>
                <td class="text-xs md:text-sm">化学、理科追加掲載編（化学）</td>
              </tr>
              <tr>
                <th>生物</th>
                <td colspan="7">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                  <span class="icon-subject-info px-1" matTooltip="Wordデータ掲載あり" matTooltipPosition="above"
                    ><app-icon-word aria-label="Wordデータ掲載あり"></app-icon-word
                  ></span>
                </td>
                <td>
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                </td>
                <td colspan="3" class="cell-disabled"></td>
                <td class="text-xs md:text-sm">生物、理科追加掲載編（生物）</td>
              </tr>
              <tr>
                <th>国語 <span class="text-primary">＊</span></th>
                <td rowspan="3" colspan="7">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                  <span class="icon-subject-info px-1" matTooltip="Wordデータ掲載あり" matTooltipPosition="above"
                    ><app-icon-word aria-label="Wordデータ掲載あり"></app-icon-word
                  ></span>
                </td>
                <td rowspan="3" colspan="4" class="cell-disabled"></td>
                <td class="text-xs md:text-sm">私立大、国公立大、追加掲載編</td>
              </tr>
              <tr>
                <th>日本史</th>
                <td class="text-xs md:text-sm">日本史、地歴追加掲載編（日本史）</td>
              </tr>
              <tr>
                <th>世界史</th>
                <td class="text-xs md:text-sm">世界史、地歴追加掲載編（世界史）</td>
              </tr>
              <tr>
                <th>地理</th>
                <td rowspan="2" colspan="6">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                  <span class="icon-subject-info px-1" matTooltip="Wordデータ掲載あり" matTooltipPosition="above"
                    ><app-icon-word aria-label="Wordデータ掲載あり"></app-icon-word
                  ></span>
                </td>
                <td rowspan="2" colspan="5" class="cell-disabled"></td>
                <td class="text-xs md:text-sm">地理、地歴追加掲載編（地理）</td>
              </tr>
              <tr>
                <th>政治・経済</th>
                <td class="text-xs md:text-sm">政治・経済</td>
              </tr>
              <tr>
                <th>英語</th>
                <td colspan="4">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                  <span class="icon-subject-info px-1" matTooltip="Wordデータ掲載あり" matTooltipPosition="above"
                    ><app-icon-word aria-label="Wordデータ掲載あり"></app-icon-word
                  ></span>
                </td>
                <td colspan="7" class="cell-disabled"></td>
                <td class="text-xs md:text-sm">私立大、国公立大、追加掲載編</td>
              </tr>
              <tr>
                <th rowspan="2">推薦・総合</th>
                <td colspan="3">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                </td>
                <td colspan="8" class="cell-disabled"></td>
                <td class="text-xs md:text-sm">
                  螢雪時代7月臨時増刊<br />
                  <span class="inline-block">大学入試　推薦＆総合型</span><span class="inline-block">合格対策ガイド</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="icon-subject-info px-1" matTooltip="問題・解答掲載あり" matTooltipPosition="above"
                    ><mat-icon class="material-icons-outlined" aria-label="問題・解答掲載あり">description</mat-icon></span
                  >
                </td>
                <td colspan="9" class="cell-disabled"></td>
                <td class="text-xs md:text-sm">学校推薦型選抜・総合型選抜（私立大）</td>
              </tr>
            </table>
          </app-overflow-wrapper-x>

          <p class="mt-2 text-sm">
            <span class="text-primary">＊</span> 国語の2019～2021年度は古文・漢文のみの掲載で、現代文の掲載はありません。<br />
            <br />
            ※ 著作権等の関係で、一部閲覧できない問題もございます。<br />
            ※ 年度についての詳細は<button class="text-primary underline hover:no-underline" (click)="gotoFaq('faq-11')">こちらのFAQ</button
            >をご覧ください。<br />
            ※ 掲載大学情報は、2025年度の一般選抜は<button
              class="text-primary underline hover:no-underline"
              (click)="universitiesListDownloadClickHandler()"
            >
              こちらを</button
            >、推薦・総合型選抜は<button
              class="text-primary underline hover:no-underline"
              (click)="specialAdmissionsListDownloadClickHandler()"
            >
              こちらを</button
            >ご覧ください。<br />
            ※ 2026年度一般選抜／推薦・総合型選抜は、2026年11月頃に搭載予定です。<br />
          </p>
        </div>
      </app-wrapper>
    </section>

    <section id="price" class="section-basic" data-bg="white">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">PLAN / PRICE</span>
        <strong class="section-basic-header-title">プランと料金</strong>
      </h2>
      <div>
        <app-wrapper size="md">
          <div class="text-center mb-8">
            <p>入試正解デジタル for School は、高校のご利用目的にあわせて選べる２つのプランをご用意しています。</p>
          </div>
          <table class="table-price mt-8">
            <thead>
              <tr>
                <th class="w-2/12 bg-white border-transparent"></th>
                <th class="w-5/12" data-cell-type="kamoku">科目プラン</th>
                <th class="w-5/12 relative" data-cell-type="zenkamoku">
                  <div class="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
                    <div class="relative bg-primary text-white px-3 py-1 rounded-full text-xs font-bold">
                      おすすめ
                      <div
                        class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-primary"
                      ></div>
                    </div>
                  </div>
                  全科目セットプラン
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>料金</th>
                <td data-cell-type="kamoku">
                  <div class="space-y-1">
                    <div>
                      <span class="mr-1 text-xs md:text-sm">英語</span
                      ><span class="whitespace-nowrap font-bold"
                        ><span class="text-base md:text-xl">132,000</span><span class="text-sm md:text-lg">円／年</span></span
                      >
                    </div>
                    <div>
                      <span class="mr-1 text-xs md:text-sm">国語</span
                      ><span class="whitespace-nowrap font-bold"
                        ><span class="text-base md:text-xl">99,000</span><span class="text-sm md:text-lg">円／年</span></span
                      >
                    </div>
                    <div class="flex flex-wrap items-center justify-center gap-x-1">
                      <span class="text-left">
                        <span class="block text-xs md:text-sm">その他科目</span>
                        <span class="block text-[10px] text-gray-700 md:text-xs">（推薦・総合プラン含む）</span>
                      </span>
                      <span class="whitespace-nowrap font-bold"
                        ><span class="text-xs font-normal">各</span><span class="text-base md:text-xl">92,400</span
                        ><span class="text-sm md:text-lg">円／年</span></span
                      >
                    </div>
                  </div>
                  <div class="mt-1 text-xs">（すべて税込）</div>
                  <div class="mt-1 text-xs text-gray-700 md:text-sm">複数科目の場合は各科目料金の合計</div>
                </td>
                <td data-cell-type="zenkamoku">
                  <div class="font-bold">
                    <span class="text-base md:text-xl">396,000</span><span class="text-sm md:text-lg">円／年</span
                    ><span class="text-xs font-normal whitespace-nowrap">（税込）</span>
                  </div>
                  <div class="mt-1 text-xs text-gray-700 md:text-sm">1科目あたり 36,000円</div>
                </td>
              </tr>
              <tr>
                <th>特徴</th>
                <td class="text-left text-xs md:text-md" data-cell-type="kamoku">
                  科目ごとにお申し込みが可能で、人数によって価格も変わります。必要な科目に絞ってのお申し込みができます。
                </td>
                <td class="text-left text-xs md:text-md" data-cell-type="zenkamoku">
                  学校内のすべての先生がご利用いただけるプランです。学校で一括採用をご検討の場合におすすめです。
                </td>
              </tr>
              <tr>
                <th>
                  利用人数<br />
                  （先生）
                </th>
                <td data-cell-type="kamoku">
                  10人まで<br />
                  <small class="leading-relaxed">
                    ※ 11人以上は1人あたり<br />
                    英語 13,200円／国語 9,900円／その他 9,240円
                  </small>
                </td>
                <td data-cell-type="zenkamoku">
                  校内無制限<br />
                  <small>※ 必要アカウント数を申請いただきます</small>
                </td>
              </tr>
              <tr>
                <th>
                  利用科目
                </th>
                <td data-cell-type="kamoku">
                  1科目ごと
                </td>
                <td data-cell-type="zenkamoku">
                  11科目すべて
                </td>
              </tr>
            </tbody>
          </table>
          <p class="mt-2 text-sm">
            ※ 「その他科目」は英語・国語を除く9科目です。<br />
            ※ プランによる機能差はありません。<br />
            ※ 契約は年単位、お支払いは年額一括のみとなります。
          </p>
          <div class="mt-6 mb-6 p-4 bg-warning-50 border-2 border-warning-200 rounded-lg flex items-start gap-3 md:gap-4">
            <mat-icon class="text-warning-600 w-6 h-6 flex-shrink-0">info</mat-icon>
            <div class="flex-grow">
              <strong class="text-gray-900 text-sm md:text-base">4科目以上ご利用の場合は全科目セットプランがお得！</strong><br />
              <span class="text-xs md:text-sm"
                >科目プラン4科目分（*415,800円）より全科目セットプラン（396,000円）が<strong class="text-gray-900">19,800円もお得</strong
                >になります。<br />
                さらに11科目すべて、<strong class="text-warning-700 font-bold">ご利用したい先生全員</strong>が使い放題！</span
              ><br />
              <span class="text-[10px] text-gray-500 md:text-xs">*科目プランを英語、国語、その他の科目2科目をご採用の場合</span>
            </div>
          </div>
          <div class="mx-auto max-w-2xl">
            <div class="mt-16 grid gap-4 md:grid-cols-2">
              <button
                id="cv-in-plan-free-trial"
                class="block w-full mat-button-override-large-in-lp cta-button-secondary"
                mat-flat-button
                (click)="freeTrialApplicationUrlClickHandler()"
              >
                無料体験の申し込み
              </button>
              <button
                id="cv-in-plan-installation"
                class="mat-button-override-large-in-lp cta-button-primary"
                mat-flat-button
                (click)="openInstallationDialog()"
              >
                新規導入の申し込み
              </button>
            </div>
          </div>
        </app-wrapper>
      </div>
    </section>

    <section id="flow" class="section-basic" data-bg="gray">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">FLOW</span>
        <strong class="section-basic-header-title">導入の流れ</strong>
      </h2>

      <app-wrapper size="md">
        <div class="sm:flex mb-4">
          <section class="flow-item">
            <h3 class="flow-item-title">
              <span>STEP 1</span>
              <strong>新規申込</strong>
            </h3>
            <div class="flow-item-body">
              <p>
                <a class="text-primary underline hover:no-underline" (click)="newInstallationUrlClickHandler()" role="button" tabindex="0"
                  >新規導入の申し込みフォーム</a
                >
                に、貴団体の基本情報、管理者情報、請求先情報などを入力いただきます。
              </p>
              <p class="text-sm text-primary -mb-1">※ お申し込みは旺文社が直接承ります。</p>
            </div>
          </section>

          <div class="flow-item-arrow">
            <mat-icon class="sm:hidden block" aria-hidden="true">arrow_drop_down</mat-icon>
            <mat-icon class="hidden sm:block" aria-hidden="true">arrow_right</mat-icon>
          </div>

          <section class="flow-item">
            <h3 class="flow-item-title">
              <span>STEP 2</span>
              <strong>利用開始</strong>
            </h3>
            <div class="flow-item-body">
              <p>
                管理者の方にアカウントを発行し、メールでご連絡いたします。<strong class="text-bold text-primary"
                  >申込日から利用開始日まで最短1週間</strong
                >です。
              </p>
            </div>
          </section>

          <div class="flow-item-arrow">
            <mat-icon class="sm:hidden block" aria-hidden="true">arrow_drop_down</mat-icon>
            <mat-icon class="hidden sm:block" aria-hidden="true">arrow_right</mat-icon>
          </div>

          <section class="flow-item">
            <h3 class="flow-item-title">
              <span>STEP 3</span>
              <strong>ユーザー登録</strong>
            </h3>
            <div class="flow-item-body">
              <p>ログイン後、アカウント管理画面から、その他の先生を登録していただきます。</p>
              <p class="text-sm text-primary -mb-1">※ アカウントご登録の際に、個々の先生のメールアドレスが必要です。</p>
            </div>
          </section>
        </div>
      </app-wrapper>
    </section>

    <section id="faq" class="section-basic" data-bg="white">
      <h2 class="section-basic-header">
        <span class="section-basic-header-lead">FAQ</span>
        <strong class="section-basic-header-title">よくあるご質問</strong>
      </h2>
      <app-wrapper size="md">
        <div class="-mx-2 mx-0">
          <div class="logs" *ngFor="let faqListItem of faqList">
            <div [id]="faqListItem.id" class="mb-4 md:mb-6">
              <app-faq-list-item [isExpanded]="faqListItem.isExpanded" [questionTitle]="faqListItem.title">
                <div class="mt-0" [innerHTML]="faqListItem.body"></div>
              </app-faq-list-item>
            </div>
          </div>
        </div>
      </app-wrapper>
    </section>

    <section id="cv-bottom" class="bottom-cta">
      <app-wrapper size="sm">
        <h2 class="bottom-cta-headline">
          『入試正解デジタル for School』は<br />
          こちらからお申し込みください
        </h2>
        <div class="mx-auto max-w-2xl">
          <div class="mt-8 grid gap-4 md:grid-cols-2">
            <button
              id="cv-bottom-installation"
              class="mat-button-override-large-in-lp cta-button-primary-in-bottom"
              mat-flat-button
              (click)="openInstallationDialog()"
            >
              新規導入の申し込み
            </button>
            <button
              id="cv-bottom-free-trial"
              class="block w-full mat-button-override-large-in-lp cta-button-secondary-in-bottom"
              mat-flat-button
              (click)="freeTrialApplicationUrlClickHandler()"
            >
              無料体験の申し込み
            </button>
          </div>
        </div>
      </app-wrapper>
    </section>
    <app-footer></app-footer>
  </div>
</main>
<div id="script"></div>
